<template>
<div v-if="hidden" >
    <!-- <div class="card-header" v-if="sID === 8">Final Report</div> -->
    <div class="card-header"><strong>{{progress === sData.length ? title + " - Results" : title}}</strong></div>
        <div class="card-body">
        <!-- <h1>{{title}}</h1> -->
        <div v-if="progress === -1">
            <img :src="require(`@/assets/${icon}`)" />
            <p>{{intro}}</p>
            <button v-on:click="beginSection">Begin Section</button>
        </div>

        <ul>
            <Question 
            v-for="(question, index) in sData" 
            :qData="question" 
            :qID="progress" 
            :hidden="index === progress"
            @nextQuestion="handleNextQuestion" 
            :key="index">
            </Question>
        </ul>

        <div v-if="progress === sData.length">
            <!-- <button v-on:click="debugSection">Check Results</button> -->
            <SWOT 
            :sData="this.formatted.S" 
            :wData="this.formatted.W" 
            :oData="this.formatted.O" 
            :tData="this.formatted.T" 
            :sID="this.sID"
            />
            
            <button v-if="sID !== 8" v-on:click="completeSection" id="NextSectionButton">Next Section</button>
        </div>

    </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";
import Question from './Question';
import SWOT from './SWOT';

export default {
    name: 'Section',
    props: {
        title: String,
        icon: String,
        intro: String,
        sData: Array,
        sID: Number,
        hidden: Boolean
    },
    components: {
        // navbar
        // Question
        Question,
        SWOT
    },
    computed: {
        ...mapGetters({
    // map `this.user` to `this.$store.getters.user`
        user: "user"
        })
    },
    methods: {
        submit(data) {
            console.log(data, this.user.data.uid, this.qID)
            // firebase.firestore()
            // .collection('sessions').doc(this.user.data.uid).set({
            //     QID: this.qID,
            //     answer: data
            // })
            // .catch(err => {
            // this.error = err.message;
            // });
            
        },
        handleNextQuestion(data) {
            this.responses[this.progress] = data;
            // let iterable = [...data]
            data.forEach(element => {
                this.formatted[element.score].push(element.value)
            })

            console.log("advance", this.formatted)

			this.progress += 1;
			// if (this.section >= this.sections.length) {
			// 	this.showResults = true;
			// }
			// console.log("results", this.results)
        },
        beginSection() {
            console.log("begin")
            this.progress = 0;
        },
        completeSection() {
            let storeSection = 'section' + this.sID
            console.log("complete")
            firebase.firestore()
            .collection(storeSection).doc(this.user.data.uid).set({
                responses: this.formatted
            })
            .catch(err => {
            this.error = err.message;
            });
            this.$emit("nextSection", this.formatted)
        },
        debugSection() {
            console.log(this.responses)
            // console.log(this.sData)
        }
    },
  data () {
    return {
      progress: -1,
      responses: [],
      formatted: {"S": [], "W": [], "O": [], "T": []}
    }
  }
}
</script>

<style scoped>
#NextSectionButton {
    margin-top: 5vh;
}

/* p {
    margin-top: 5vh;
} */

img {
    max-height: 30vh;
    filter: invert(19%) sepia(1%) saturate(554%) hue-rotate(314deg) brightness(85%) contrast(102%);


}
</style>